 
 <template>
  <div>
    <div class="d-sm-down-none m-0 mt-5">
      <CCard class="custom-menu">
        <CCol sm="12">
          <CRow>
            <CCol sm="3" @click="GoToDashBoard()">
              <CIcon
                style="color: darkcyan"
                name="cil-list-rich"
                width="25px"
                title="Daily Quiz"
              />
              <div style="color: #000" title="Daily Quiz">Quiz</div>
            </CCol>
            <CCol sm="3" @click="GoToTest()">
              <CIcon
                style="color: darkcyan"
                name="cil-clipboard"
                width="25px"
                title="Daily Quiz"
              />
              <div style="color: #000" title="Daily Quiz">Compete</div>
            </CCol>
            <CCol sm="3" @click="GoToStatistic()">
              <CIcon
                style="color: darkcyan"
                name="cil-chart"
                width="25px"
                title="Daily Quiz"
              />
              <div style="color: #000" title="Daily Quiz">Statistic</div>
            </CCol>
            <CCol sm="3"  @click="GoToTeacherProfile()">
              <CIcon
                style="color: darkcyan"
                name="cil-user"
                width="25px"
                title="Daily Quiz"
              />
              <div style="color: #000" title="Daily Quiz">Account</div>
            </CCol>





            
          </CRow>
        </CCol>
      </CCard>


     

    </div>


     <div
      style="
        background-size: cover;
        color: #fff;
        position: fixed;
        width: 100%;
        top: 80px;
        z-index: 1;
        right:1px
      "
    class="d-md-none d-lg-none">
      <CRow class="justify-content-center">
        <CCol
          style="display: flex; align-items: center; justify-content: center"
          align="center"
        >
          <CCol sm="12" lg="12"><br />
            <CCard class="p-1 box-shadow">
              <CCol
                sm="12"
                lg="12"
                style="
                  display: flex;
                  align-items: center;
                  justify-content: center;
                "
              >
                <CCol
                  sm="3"
                  lg="3"
                  @click="GoToDashBoard()"
                  class="p-0 m-0"
                  style="flex: 1"
                >
                    <CIcon
                      style="color: darkcyan"
                      name="cil-list-rich"
                      width="25px"
                      title="Daily Quiz"
                    />
                    <div style="color:#000" title="Daily Quiz">Quiz</div>
                </CCol>

                <CCol
                  sm="3"
                  lg="3"
                  @click="GoToTest()"
                  class="p-0 m-0"
                  style="flex: 1"
                >
                    <CIcon
                      style="color: darkcyan"
                      name="cil-clipboard"
                      width="25px"
                    />
                    <!-- <img src="../assets/img/icontest.png" width="30px" /> -->
                    <div style="color:#000">Compete</div>
                </CCol>

                <CCol
                  sm="3"
                  lg="3"
                  @click="GoToStatistic()"
                  class="p-0 m-0"
                  style="flex: 1"
                >
                    <CIcon
                      style="color: darkcyan"
                      name="cil-chart"
                      width="25px"
                      title="Score Card"
                    />
                    <!-- <img src="../assets/img/iconscorerate.png" width="30px" /> -->
                    <div style="color:#000" title="Score Card">Statistic</div>
                </CCol>

                <CCol
                  sm="3"
                  lg="3"
                  @click="GoToTeacherProfile()"
                  class="p-0 m-0"
                  style="flex: 1"
                >
                    <CIcon
                      style="color: darkcyan"
                      name="cil-user"
                      width="25px"
                      title="My Account"
                    />
                    <!-- <img src="../assets/img/usernobg.png" width="30px" /> -->
                    <div style="color:#000" title="My Account">
                      Account
                    </div>
                </CCol>
                
              </CCol>
            </CCard>
          </CCol>
        </CCol>
      </CRow>
    </div>

    
  </div>
</template>
 
  


    
<script>
import Vue from "vue";
import FullCalendar from "vue-full-calendar";
import "fullcalendar/dist/fullcalendar.css";
import backgroundUrl from "../assets/img/bgtips.png";

import _ from "lodash";
import PulseLoader from "vue-spinner/src/PulseLoader.vue";
import { CChartBar } from "@coreui/vue-chartjs";
import VueEllipseProgress from "vue-ellipse-progress";

//import "@fullcalendar/core/vdom"; // solves problem with Vite]

import { Calendar } from "vue-sweet-calendar";
import "vue-sweet-calendar/dist/SweetCalendar.css";

Vue.use(FullCalendar);
Vue.use(VueEllipseProgress);

export default {
  name: "Collapses",
  components: {
    PulseLoader,
    CChartBar,
    Calendar,
  },
  data() {
    return {
      backgroundUrl,
      user: {},
      studentProfile: {},
      news: [],
      student: [],
      childs: [],
      studentProfileAuthorize: "",
    };
  },
  async mounted() {
    this.SessionUserIdNo();
    let isAuth = await this.UserAuth();

    if (isAuth) {
      this.Busy = false;
      this.GetUserProfile();
      this.GetListChild();
      this.GetAuthorizeProfile();
    } else {
      this.GoToLogin();
    }
  },
  computed: {},

  methods: {
    SessionUserIdNo() {
      return this.$API
        .get(this.$LoginUserDetailWebs, {
          withCredentials: true,
        })
        .then((response) => {
          if (response.status == 200) {
            this.user = response.data;
            console.log(":testing" + this.user.id);
          }
        });
    },
     GoToDashBoard() {
      this.$router.push(
        "/QuizTeacherDashboard?userId=" + this.user.id
      );
    },
    GoToTest() {
      this.$router.push(
        "/QuizTeacherTestOverview?userId=" + this.user.id
      );
    },
    GoToTeacherProfile() {
      this.$router.push(
        "/QuizTeacherProfile?userId=" + this.user.id
      );
    },
    GoToStatistic() {
      this.$router.push(
        "/QuizTeacherStatistic?userId=" + this.user.id
      );
    },
  },
};
</script>

<style scoped>
#wrapper { width: 300px; background: orange; margin: 0 auto; position: relative; }
#feedback { position: fixed; right: 0; top: 120px; }
</style>
    